module.exports = __webpack_public_path__ + "img/fondo-banner-principal.a695c3b6.svg";